import React, { ReactNode } from "react";
import { connect, ConnectedProps } from "react-redux";
import {
  Permission,
  useIsSuperPlusAdmin,
  useRequirePermissionSets,
  useSatisfyPermissionSets,
} from "../hooks/permission";

type PermissionWrapperType = "conditionalRender" | "displayNone" | "opacity";

type PermissionWrapperProps = React.PropsWithChildren<{
  requiredPermissionSets?: Permission[][];
  // [[a,b],[c,d]] = has permission a&b or c&d
  requireSuperPlusAdmin?: boolean;
  type?: PermissionWrapperType;
  noPermissionChildren?: ReactNode;
  extraCheck?: boolean;
}>;

const connector = connect(
  (state: { getMyAccountInfo: any; getMyAuthority: any }) => ({
    accountInfo: state?.getMyAccountInfo?.data,
  }),
  {},
);

type PermissionWrapperPropsWithRedux = ConnectedProps<typeof connector> &
  PermissionWrapperProps;

const PermissionWrapper = ({
  requiredPermissionSets = [[]],
  requireSuperPlusAdmin = false,
  type = "conditionalRender",
  noPermissionChildren = null,
  extraCheck = true,
  children,
}: PermissionWrapperPropsWithRedux) => {
  const satisfyPermissionSets =
    useSatisfyPermissionSets(requiredPermissionSets, requireSuperPlusAdmin) &&
    extraCheck;

  switch (type) {
    case "displayNone":
      return (
        <>
          <div style={satisfyPermissionSets ? {} : { display: "none" }}>
            {children}
          </div>
          <div style={satisfyPermissionSets ? { display: "none" } : {}}>
            {noPermissionChildren}
          </div>
        </>
      );
    case "opacity":
      return (
        <>
          <div style={{ opacity: satisfyPermissionSets ? 1 : 0 }}>
            {children}
          </div>
          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              opacity: satisfyPermissionSets ? 0 : 1,
            }}
          >
            {noPermissionChildren}
          </div>
        </>
      );
    case "conditionalRender":
    default:
      return satisfyPermissionSets ? (
        <>{children}</>
      ) : noPermissionChildren === null ? null : (
        <>{noPermissionChildren}</>
      );
  }
};

export default connector(PermissionWrapper);
